<div class="layout-row layout-align-start-end time-dropdown">
  <bz-select class="flex"
             size="sm"
             appBringozIdGenerator="timeDropdownHour"
             [label]="'Hour' | translate"
             [options]="hourOptions"
             [value]="selected().hour"
             [disabled]="isDisabled()"
             (valueChange)="onHourChange($event)">
  </bz-select>

  <span class="time-separator">:</span>

  <bz-select class="flex"
             size="sm"
             appBringozIdGenerator="timeDropdownMinute"
             [label]="'Minute' | translate"
             [options]="minuteOptions"
             [value]="selected().minute"
             [disabled]="isDisabled()"
             (valueChange)="onMinuteChange($event)">
  </bz-select>
</div>
